export default __webpack_public_path__ + "static/media/pdffile.d878bc64.svg";